<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="setting.use_productionrouting_is_possible === '0'" [ttModel]="setting.warning_message"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input ttLabel="prod_id" [ttModel]="setting.prod_id" ttReadonly></tt-input>
        <tt-select ttLabel="productionrouting" [(ttModel)]="setting.productionrouting_keyno" (ttModelChange)="onChanged($event, 'productionrouting_keyno')" [ttData]="selectListProductionRoutings" ttDataId="productionrouting_keyno" ttDataName="productionroutinglang_name"></tt-select>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
